export const domain = 'barefootwear.org'
export const url = 'https://www.barefootwear.org'
export const title = 'Barefootwear'

export const getSiteUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:8888"
  } else if (process.env.NODE_ENV === "production" && window.location.port === "9000") {
    return "http://localhost:9000"
  } else {
    return url
  }
}

export const menu = {
  items: [
    {
      title: 'Guides',
      key: 'guides',
      subItems: [
        {
          title: 'Zero-Drop', 
          key: 'transition',
          to: 'https://youtu.be/i2D7BUOAe8g'
        },
        {
          title: 'Barefoot',
          key: 'comics',
          url: 'https://youtu.be/oUUdYgHvv70'
        },
        {
          title: 'Videos',
          key: 'videos',
          url: 'https://www.youtube.com/@AndrewFolts'
        }
      ]
    },
    {
      title: 'Footwear',
      key: 'Footwear',
      subItems: [
        {
          title: 'Shoe Finder',
          key: 'shoe-finder',
          to: '/barefoot-shoe-finder'
        },
        // {
        //   title: 'Compare Tool',
        //   key: 'compare',
        //   to: '/compare'
        // },
        {
          title: 'Best Lists',
          key: 'best-lists',
          to: '/lists'
        },
        // {
        //   title: 'Top Picks',
        //   key: 'andrews-favorites',
        //   to: '/lists/andrews-favorites'
        // }
      ]
    },
    {
      title: 'Contact',
      key: 'contact',
      to: 'https://bit.ly/44mIITz'
    }
  ]
}

export default  {
 domain,
 title,
 url ,
 menu,
 getSiteUrl
}